import { PROJECTS } from "@/data/projects";
import { useWindows } from "@/os/window/context";
import { play } from "@/lib/sound";

export function Experiments() {
    const { open } = useWindows();
    return (
        <div data-testid="experiments">
            <p className="font-mono text-[11px] text-inkfaint">
                {PROJECTS.length} labs · each opens with problem, approach, tech, contribution, challenges and lessons. demos are simulations —
                nothing here pretends to be live.
            </p>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {PROJECTS.map((p) => {
                    const Icon = p.icon;
                    return (
                        <button
                            key={p.id}
                            data-testid={`project-card-${p.id}`}
                            onClick={() => {
                                play("click");
                                open(`project:${p.id}`);
                            }}
                            className="rounded-2xl border-2 border-ink bg-paper p-4 text-left shadow-[3px_3px_0_#1C1917] transition-transform hover:-translate-y-0.5"
                        >
                            <div className="flex items-center gap-3">
                                <span className="grid h-10 w-10 flex-none place-items-center rounded-xl border-2 border-ink" style={{ background: p.tileBg, color: p.color }}>
                                    <Icon size={20} />
                                </span>
                                <div className="min-w-0">
                                    <p className="truncate font-mono text-[12px] font-bold text-ink">{p.name}</p>
                                    <p className="text-[12px] text-inksoft">{p.tagline}</p>
                                </div>
                            </div>
                            <div className="mt-3 flex flex-wrap gap-1">
                                {p.tech.slice(0, 3).map((t) => (
                                    <span key={t} className="chip">
                                        {t}
                                    </span>
                                ))}
                                {p.tech.length > 3 && <span className="chip">+{p.tech.length - 3}</span>}
                            </div>
                            <span className="badge mt-3 border-elec text-elec">interactive demo</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
